// Header Component
import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Pane, Heading, Button, Text, Link as EvergreenLink } from 'evergreen-ui';
import { Link as ScrollLink } from 'react-scroll'; // React Scroll for smooth scrolling
import { auth } from '../appservices/firebase';
import useStore from '../appservices/store';
import { onAuthStateChanged } from 'firebase/auth'; // Import for listening to auth state changes

import konstantlogo from '../assets/logos/konstant_logo.png'; // Replace with the actual path if different
import konstant_logo_white from '../assets/logos/konstant_logo_white.png'; // Replace with the actual path if different

 // Header.js

 


 const Header00 = () => {
  const { user } = useStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/auth');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const isDashboard = location.pathname.includes('/dashboard');

  return (
    <Pane
      display="flex"
      padding={24}
      alignItems="center"
      justifyContent="space-between"
      background="white"
      position="sticky"
      top={0}
      zIndex={1000}
    >
      {/* Logo */}
      <Pane display="flex" alignItems="center">
        <img
          src={konstant_logo_white}
          alt="Logo"
          style={{ height: '40px', marginRight: '12px', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
      </Pane>

      {/* Navigation Links */}
      <Pane display="flex" gap={24} alignItems="center">
        {!isDashboard ? (
          <>
            <ScrollLink
              to="home"
              smooth={true}
              duration={500}
              style={{ textDecoration: 'none', color: 'black', fontSize: '16px', cursor: 'pointer' }}
            >
              Home
            </ScrollLink>
            <ScrollLink
              to="features"
              smooth={true}
              duration={500}
              style={{ textDecoration: 'none', color: 'black', fontSize: '16px', cursor: 'pointer' }}
            >
              How It Works
            </ScrollLink>
            <ScrollLink
              to="faqs"
              smooth={true}
              duration={500}
              style={{ textDecoration: 'none', color: 'black', fontSize: '16px', cursor: 'pointer' }}
            >
              FAQs
            </ScrollLink>
            <ScrollLink
              to="pricing"
              smooth={true}
              duration={500}
              style={{ textDecoration: 'none', color: 'black', fontSize: '16px', cursor: 'pointer' }}
            >
              Pricing
            </ScrollLink>
            <ScrollLink
              to="contact"
              smooth={true}
              duration={500}
              style={{ textDecoration: 'none', color: 'black', fontSize: '16px', cursor: 'pointer' }}
            >
             For Home 
            </ScrollLink>

            <ScrollLink
              to="contact"
              smooth={true}
              duration={500}
              style={{ textDecoration: 'none', color: 'black', fontSize: '16px', cursor: 'pointer' }}
            >
             For Office 
            </ScrollLink>
          </>
        ) : (
          <>
            <Link to="/dashboard" style={{ textDecoration: 'none', color: 'black', fontSize: '16px' }}>
              Overview
            </Link>
            <Link to="/dashboard/settings" style={{ textDecoration: 'none', color: 'black', fontSize: '16px' }}>
              Settings
            </Link>
            <Link to="/dashboard/reports" style={{ textDecoration: 'none', color: 'black', fontSize: '16px' }}>
              Reports
            </Link>
          </>
        )}

        {/* User Account Actions */}
        {user ? (
          <>
            {isDashboard ? (
              <Button appearance="primary" height={40} onClick={handleLogout}>
                Logout
              </Button>
            ) : (
              <Button appearance="primary" height={40} onClick={() => navigate('/dashboard')}>
                Dashboard
              </Button>
            )}
          </>
        ) : (
          <Button appearance="primary" height={40} onClick={() => navigate('/auth')}>
            Login / Signup
          </Button>
        )}

  
      </Pane>
      <Pane display="flex" gap={16} alignItems="center">
      {/* Book a Demo Button */}
            <Button
              appearance="primary"
              height={40}
              onClick={() => window.open('https://cal.com/ola-projects-8hijhu', '_blank')}
            >
              Book a Demo
            </Button>
        {/* Contact Us Link */}
        </Pane>

    </Pane>
  );
};

 
 

 const Header = () => {
  const { user } = useStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/auth');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const isDashboard = location.pathname.includes('/dashboard');

  return (
    <Pane
      display="flex"
      padding={24}
      alignItems="center"
      justifyContent="space-between"
      background="white"
      position="sticky"
      top={0}
      zIndex={1000}
    >
      {/* Logo */}
      <Pane display="flex" alignItems="center">
        <img
          src={konstant_logo_white}
          alt="Logo"
          style={{ height: '40px', marginRight: '12px', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
      </Pane>

      {/* Navigation Links */}
      <Pane display="flex" gap={24} alignItems="center">


        {/* Book a Demo Button */}
        <Button
          appearance="primary"
          height={40}
          onClick={() => window.open('https://cal.com/ola-projects-8hijhu', '_blank')}
        >
          Book a Demo
        </Button>
      </Pane>
    </Pane>
  );
};

 
 

 



 
// Footer Component
 
const Footer = () => (
  <Pane
    paddingY={48}
    paddingX={32}
    background="tint1"
    textAlign="center"
    display="flex"
    flexDirection="column"
    alignItems="center"
    borderTop="muted"
  >
    {/* Logo */}
    <Pane marginBottom={24}>
      <img
        src={konstant_logo_white}
        alt="Logo"
        style={{ height: '40px' }}
      />
    </Pane>

    {/* Copyright Text */}
    <Text size={400} color="muted" marginBottom={16}>
      © 2024 Konstant. All rights reserved.
    </Text>

    {/* Navigation Links */}
    <Pane display="flex" gap={32} justifyContent="center" marginBottom={16}>
      <ScrollLink to="home" smooth={true} duration={500} style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}>
        Home
      </ScrollLink>
      <ScrollLink to="features" smooth={true} duration={500} style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}>
        Features
      </ScrollLink>
      <ScrollLink to="faqs" smooth={true} duration={500} style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}>
        FAQs
      </ScrollLink>
      <ScrollLink to="contact" smooth={true} duration={500} style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}>
        Contact
      </ScrollLink>
    </Pane>

    {/* Legal Links */}
    <Pane display="flex" gap={16} justifyContent="center">
      <Link to="/privacy" style={{ textDecoration: 'none', color: 'black' }}>
        <Text size={400}>Privacy Policy</Text>
      </Link>
      <Link to="/terms" style={{ textDecoration: 'none', color: 'black' }}>
        <Text size={400}>Terms & Conditions</Text>
      </Link>
    </Pane>
  </Pane>
);

 



export default Header;
export { Footer };
